import * as React from "react";
import { KitModel } from "@app/api2/api";
import { Link } from "react-router-dom";
import { PageHeader } from "@common/PageHeader";
import { BPColumn } from "@common/BPReactTable";
import { kitClient } from "@app/api2/Clients";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { BPContainer } from "@/components/bp/bpcontainer";

interface IKitsListProps {
    baseUrl: string;
}



export const KitsList: React.FC<IKitsListProps> = (props) => {

    const dotdotdotStyle: React.CSSProperties = { 'overflow': 'hidden', 'textOverflow': 'ellipsis', whiteSpace: "nowrap" };
    const columns: BPColumn<KitModel>[] = [
        {
            Header: window.translation.kitView.shortName,
            accessor: 'shortName',
            Cell: item => <Link to={`${item.row.original.id}/detail`}>{item.value}</Link>,
            tableCellProps: {
                width: 6
            }
        },
        {
            Header: window.translation.kitView.fullName,
            accessor: 'fullName',
        },
    ];

    // const columnDefs = convertColumns(columns);
    // const table = useBpReactTable2<KitModel>({
    //     queryKeyPrefix: 'KitsList',
    //     query: async (paging, sorting, searchValue, filters) => {
    //         let pageData = await kitClient.getAll(paging.pageSize, paging.pageIndex + 1, sorting[0]?.id, sorting[0]?.desc ? 'desc' : 'asc', searchValue);
    //         return { rowCount: pageData.totalRows, rows: pageData.items }
    //     },
    //     columnDefs: columnDefs,
    //     defaultSortingState: [{ id: 'shortName', desc: false }],
    // });

    return (
        <BPContainer>
            <PageHeader header={window.translation.common.kits} />
            {/* <BPReactTable2 {...table} /> */}
            <BPDataTable3
                storeKey="KitList"
                defaultSortField="shortName"
                defaultSortAsc={true}
                enableSearch={true}
                dataSource={async (p) => {
                    let pageData = await kitClient.getAll(p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue);
                    return pageData;
                }}
                columns={columns} />
        </BPContainer>
    );

}
